import { f as _defineProperty, c as _inherits, d as _createSuper, e as _classCallCheck, g as _assertThisInitialized } from '../../../dist/defineProperty-990a7015.esm.js';
import * as t from 'io-ts';
import * as E from 'fp-ts/lib/Either';
import { withValidate } from 'io-ts-types/lib/withValidate';
import { pipe } from 'fp-ts/lib/function';
import { fromNullable as fromNullable$1 } from 'io-ts-types/lib/fromNullable';
import words from 'lodash/words';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var NullableType = /*#__PURE__*/function (_t$Type) {
  _inherits(NullableType, _t$Type);

  var _super = _createSuper(NullableType);

  function NullableType(name, is, validate, encode, type) {
    var _this;

    _classCallCheck(this, NullableType);

    _this = _super.call(this, name, is, validate, encode);

    _defineProperty(_assertThisInitialized(_this), "_tag", 'NullableType');

    _this.type = type;
    return _this;
  }

  return NullableType;
}(t.Type);
var nullable = function nullable(codec) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "".concat(codec.name, " | null");
  return new NullableType(name, function (u) {
    return u === null || codec.is(u);
  }, function (u, c) {
    return u == null ? t.success(null) : codec.validate(u, c);
  }, function (a) {
    return a == null ? null : codec.encode(a);
  }, codec);
};

var fromNullable = function fromNullable(codec, a, name) {
  return fromNullable$1(codec, a, name !== null && name !== void 0 ? name : codec.name);
};

var _CWM_FEATURE_CLASSES, _CWM_EPISODE_CLASSES, _CWM_SERIES_CLASSES;

var CWM_CLASS_TYPE_FEATURE_FILM = 'http://data.disney.com/creativeWork#FeatureFilm';
var CWM_CLASS_TYPE_FEATURETTE = 'http://data.disney.com/creativeWork#Featurette';
var CWM_CLASS_TYPE_HOME_VIDEO = 'http://data.disney.com/creativeWork#HomeVideo';
var CWM_CLASS_TYPE_SHORT = 'http://data.disney.com/creativeWork#Short';
var CWM_CLASS_TYPE_DIGITAL_SHORT = 'http://data.disney.com/creativeWork#DigitalShort';
var CWM_CLASS_TYPE_SPECIAL = 'http://data.disney.com/creativeWork#Special';
var CWM_CLASS_TYPE_TV_MOVIE = 'http://data.disney.com/creativeWork#TVMovie';
var CWM_BASE_CLASS_FEATURE = 'feature';
var CWM_FEATURE_CLASSES = (_CWM_FEATURE_CLASSES = {}, _defineProperty(_CWM_FEATURE_CLASSES, CWM_CLASS_TYPE_FEATURE_FILM, null), _defineProperty(_CWM_FEATURE_CLASSES, CWM_CLASS_TYPE_FEATURETTE, null), _defineProperty(_CWM_FEATURE_CLASSES, CWM_CLASS_TYPE_HOME_VIDEO, null), _defineProperty(_CWM_FEATURE_CLASSES, CWM_CLASS_TYPE_SHORT, null), _defineProperty(_CWM_FEATURE_CLASSES, CWM_CLASS_TYPE_DIGITAL_SHORT, null), _defineProperty(_CWM_FEATURE_CLASSES, CWM_CLASS_TYPE_SPECIAL, null), _defineProperty(_CWM_FEATURE_CLASSES, CWM_CLASS_TYPE_TV_MOVIE, null), _CWM_FEATURE_CLASSES);
var isFeature = function isFeature(cwmClassType) {
  return Object.keys(CWM_FEATURE_CLASSES).includes(cwmClassType);
}; // Episodes

var CWM_BASE_CLASS_EPISODE = 'episode';
var CWM_CLASS_TYPE_EPISODE = 'http://data.disney.com/creativeWork#Episode';
var CWM_CLASS_TYPE_PRE_AIR_EPISODE = 'http://data.disney.com/creativeWork#PreAirEpisode';
var CWM_EPISODE_CLASSES = (_CWM_EPISODE_CLASSES = {}, _defineProperty(_CWM_EPISODE_CLASSES, CWM_CLASS_TYPE_EPISODE, null), _defineProperty(_CWM_EPISODE_CLASSES, CWM_CLASS_TYPE_PRE_AIR_EPISODE, null), _CWM_EPISODE_CLASSES);
var isEpisode = function isEpisode(cwmClassType) {
  return Object.keys(CWM_EPISODE_CLASSES).includes(cwmClassType);
}; // Series

var CWM_BASE_CLASS_SERIES = 'series';
var CWM_CLASS_TYPE_PILOT_SERIES = 'http://data.disney.com/creativeWork#PilotSeries';
var CWM_CLASS_TYPE_MINISERIES = 'http://data.disney.com/creativeWork#Miniseries';
var CWM_CLASS_TYPE_SERIES = 'http://data.disney.com/creativeWork#Series';
var CWM_CLASS_TYPE_NEWS_PROGRAM = 'http://data.disney.com/creativeWork#NewsProgram';
var CWM_CLASS_TYPE_TALK_SHOW = 'http://data.disney.com/creativeWork#TalkShow';
var CWM_SERIES_CLASSES = (_CWM_SERIES_CLASSES = {}, _defineProperty(_CWM_SERIES_CLASSES, CWM_CLASS_TYPE_PILOT_SERIES, null), _defineProperty(_CWM_SERIES_CLASSES, CWM_CLASS_TYPE_MINISERIES, null), _defineProperty(_CWM_SERIES_CLASSES, CWM_CLASS_TYPE_SERIES, null), _defineProperty(_CWM_SERIES_CLASSES, CWM_CLASS_TYPE_NEWS_PROGRAM, null), _defineProperty(_CWM_SERIES_CLASSES, CWM_CLASS_TYPE_TALK_SHOW, null), _CWM_SERIES_CLASSES);
var isSeries = function isSeries(cwmClassType) {
  return Object.keys(CWM_SERIES_CLASSES).includes(cwmClassType);
}; // Season

var CWM_BASE_CLASS_SEASON = 'season';
var CWM_CLASS_TYPE_SEASON_OF_SERIES = 'http://data.disney.com/serialWork#SeasonOfSeries';
var CWM_SEASON_CLASSES = _defineProperty({}, CWM_CLASS_TYPE_SEASON_OF_SERIES, null);
var isSeason = function isSeason(cwmClassType) {
  return Object.keys(CWM_SEASON_CLASSES).includes(cwmClassType);
};
var CWMClassTypeAnyCodec = t.keyof(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, CWM_FEATURE_CLASSES), CWM_EPISODE_CLASSES), CWM_SERIES_CLASSES), CWM_SEASON_CLASSES));
function makeCWMTypeLabelCodec(cwmClassTypeProp, cwmClassTypeLabelProp, cwmClassTypeDefault) {
  var _t$type;

  var CWMTypeLabelBase = t.type((_t$type = {}, _defineProperty(_t$type, cwmClassTypeProp, cwmClassTypeDefault ? fromNullable(t.string, cwmClassTypeDefault) : t.string), _defineProperty(_t$type, cwmClassTypeLabelProp, nullable(t.string)), _t$type));
  return withValidate(CWMTypeLabelBase, function (u, c) {
    return pipe(CWMTypeLabelBase.validate(u, c), E.map(function (obj) {
      var _obj$cwmClassTypeLabe;

      return _objectSpread2(_objectSpread2({}, obj), {}, _defineProperty({}, cwmClassTypeLabelProp, (_obj$cwmClassTypeLabe = obj[cwmClassTypeLabelProp]) !== null && _obj$cwmClassTypeLabe !== void 0 ? _obj$cwmClassTypeLabe : cwmClassTypeToLabel(obj[cwmClassTypeProp])));
    }));
  });
}
function cwmClassTypeToLabel(cwmClassType) {
  return words(cwmClassType.split('#')[1] || '').join(' ');
} // eslint-disable-next-line

var CWMTypeLabelCodec = function CWMTypeLabelCodec(cwmClassTypeDefault) {
  return makeCWMTypeLabelCodec('cwmClassType', 'cwmClassTypeLabel', cwmClassTypeDefault);
};
var getCWMBaseClass = function getCWMBaseClass(_ref) {
  var cwmClassType = _ref.cwmClassType;

  if (isFeature(cwmClassType)) {
    return CWM_BASE_CLASS_FEATURE;
  }

  if (isSeries(cwmClassType)) {
    return CWM_BASE_CLASS_SERIES;
  }

  if (isEpisode(cwmClassType)) {
    return CWM_BASE_CLASS_EPISODE;
  }

  if (isSeason(cwmClassType)) {
    return CWM_BASE_CLASS_SEASON;
  }

  throw new Error("Cannot find base CWM class for \"".concat(cwmClassType, "\""));
};

export { CWMClassTypeAnyCodec, CWMTypeLabelCodec, CWM_BASE_CLASS_EPISODE, CWM_BASE_CLASS_FEATURE, CWM_BASE_CLASS_SEASON, CWM_BASE_CLASS_SERIES, CWM_CLASS_TYPE_DIGITAL_SHORT, CWM_CLASS_TYPE_EPISODE, CWM_CLASS_TYPE_FEATURETTE, CWM_CLASS_TYPE_FEATURE_FILM, CWM_CLASS_TYPE_HOME_VIDEO, CWM_CLASS_TYPE_MINISERIES, CWM_CLASS_TYPE_NEWS_PROGRAM, CWM_CLASS_TYPE_PILOT_SERIES, CWM_CLASS_TYPE_PRE_AIR_EPISODE, CWM_CLASS_TYPE_SEASON_OF_SERIES, CWM_CLASS_TYPE_SERIES, CWM_CLASS_TYPE_SHORT, CWM_CLASS_TYPE_SPECIAL, CWM_CLASS_TYPE_TALK_SHOW, CWM_CLASS_TYPE_TV_MOVIE, CWM_EPISODE_CLASSES, CWM_FEATURE_CLASSES, CWM_SEASON_CLASSES, CWM_SERIES_CLASSES, cwmClassTypeToLabel, getCWMBaseClass, isEpisode, isFeature, isSeason, isSeries, makeCWMTypeLabelCodec };
